import { Dialog, Alert, Stack, IconButton } from "@mui/material";
import { useContext } from "react";
import { MainContext } from "../../context/MainContextProvider";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export function ActionAlert(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;

  severity: "success" | "error" | "info" | "warning";
  message: string;
  errorDetails?: string;
}) {
  const { open, setOpen, severity, message, errorDetails } = props;
  const { setToastNotifications } = useContext(MainContext);
  const onClose = () => {
    setOpen(false);
    props.onClose && props.onClose();
  };
  const onShowErrorDetails = () => {
    setToastNotifications({
      isAdding: true,
      notifications: [
        {
          severity: "error" as const,
          text: errorDetails,
        },
      ],
    });
  };

  const theme = createTheme({
    components: {
      MuiAlert: {
        styleOverrides: {
          filledWarning: {
            backgroundColor: "#EE7D00",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          width: "100%",
          display: "flex",
          marginTop: { xs: "-400px", md: " -500px" },
          justifyContent: "center",
        }}
      >
        <Stack sx={{ width: { xs: "100%", md: "350px" } }} spacing={2}>
          <Alert
            // variant="filled"
            severity={severity}
            onClose={onClose}
            sx={{ fontSize: { xs: "16px", md: "14px" } }}
          >
            {message}
            {errorDetails && (
              <IconButton
                aria-label="show details"
                size="small"
                onClick={onShowErrorDetails}
              >
                <ErrorOutlineIcon />
              </IconButton>
            )}
          </Alert>
        </Stack>
      </Dialog>
    </ThemeProvider>
  );
}
